import { createAsyncThunk } from '@reduxjs/toolkit';
import moment from 'moment';
import createNotification from '../../../../utils/createNotification';
import { EngagementClosingDate } from '../models/engagement-closing-date.model';

export interface ProposeClosingDateArg {
    engagementId: number;
    proposedDate: Date;
    comment: string;
}

export const ProposeClosingDate = createAsyncThunk(
    'closingDate/propose',
    async (arg: ProposeClosingDateArg, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        const response = await axios.post(
            `/api/Marketplace/Engagements/${arg.engagementId}/ClosingDate/Proposals`,
            {
                proposedDate: moment(arg.proposedDate).format('YYYY-MM-DD'),
                comment: arg.comment,
            }
        );

        if (response.status !== 200) {
            const message =
                response?.response?.data?.title ??
                response?.response?.data?.detail ??
                'An error occurred while proposing the closing date.';
            createNotification(message, 'error');
            throw new Error('Failed to propose closing date');
        }

        createNotification('Closing date proposed successfully.', 'success');
        return response.data as EngagementClosingDate;
    }
);
